<template>
	<section class="addresses-map">
		<div ref="map" id="map">
		</div>
		<div class="addresses-route" v-if="routeData.showRouter">
			<div class="addresses-route__close" @click="routeData.showRouter = false"></div>
			<div class="addresses-route__title">Построить маршрут</div>
			<div class="addresses-route__form">
				<div class="default-input">
					<div class="default-input__select">
						<Multiselect
							:placeholder="'Откуда'"
							:searchable="true"
							:filter-results="false"
							v-model="routeData.addressFrom"
							:resolve-on-load="false"
							:min-chars="3"
							:delay="700"
							:object="true"
							:valueProp="'name'"
							:loading="false"
							:track-by="'name'"
							:label="'name'"
							:caret="false"
							:noResultsText="'Ничего не нашлось'"
							:noOptionsText="routeData.searching ? 'Ничего не нашлось' : 'Начните вводить адрес'"
							:clearOnSearch="false"
							:can-clear="false"
							:can-deselect="false"
							@search-change="function(query, select$) {
                                if (query) {
									routeData.searching = true
                                } else {
									routeData.searching = false
                                }
                            }"
							@select="setSearchAddress"
							:options="async function(query) {
                                    return await searchAddress(query)
                                }"
						>
							<template #placeholder>
								<div class="multiselect-placeholder">
									<span>Откуда</span>
								</div>
							</template>
						</Multiselect>
					</div>
				</div>
				<button class="addresses-route__geo" @click="getUserGeolocation" :disabled="!geoRights"
						:title="!geoRights ? 'Разрешите сайту использовать ваши Геоданные' : ''"
						:class="{'addresses-route__geo--disabled' : !geoRights}">Мое местоположение
				</button>
				<div class="default-input">
					<div class="default-input__input">
						<input type="text" :value="routeData.addressTo.name" :disabled="true" placeholder="Куда">
					</div>
				</div>
				<div class="addresses-route__btn btn color shadow" @click="buildRoute">Построить</div>
			</div>
		</div>
	</section>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import Multiselect from "@vueform/multiselect";
// eslint-disable-next-line
let mapsConstructor,
	mapInstance,
	// mapSearch,
	clusterer,
	userPlacemark,
	multiRoute



export default {
	name: "PawnshopsMap",
	components: {
		Multiselect
	},
	data() {
		return {
			geoRights: false,
			customBalloon: null,
			zoom: 10,
			center: [0, 0],
			userGeoLocation: null,
			routeData: {
				searching: false,
				showRouter: false,
				addressFrom: {
					name: '',
					coords: [],
				},
				addressTo: {
					name: '',
					coords: [],
				},
			}

		}
	},
	mounted() {
		this.center = this.getInitialCords();
		this.checkGeoRights();

		if (document.querySelector('#ymaps-component')) {
			this.initMap()
		} else {
			let script = document.createElement('script')
			script.id = 'ymaps-component'
			script.setAttribute('src', 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&load=package.full&apikey=124db383-e7af-4d09-9bfb-cdabba0d7a65&suggest_apikey=3c0c4d4d-5157-4f63-8741-703632136f83')
			document.head.appendChild(script)
			script.onload = () => {
				// eslint-disable-next-line
				mapsConstructor = ymaps;
				mapsConstructor.ready(this.initMap);
			}
		}
	},
	computed: {
		ymapState() {
			return {
				zoom: this.zoom,
				center: this.center,
				controls: [],
                duration: 1000
			}
		},
		currentPlacemark() {
			if (this.currentPawn) {
				switch (this.currentPawn.theme) {
					case 'pectoral':
						return '/local/templates/.default/img/svg/pectoral-placemark.svg'
					case 'green':
						return '/local/templates/.default/img/svg/donskoy-placemark.svg'
					default:
						return '/local/templates/.default/img/svg/placemark.svg'
				}
			} else {
				return '/local/templates/.default/img/svg/placemark.svg'
			}
		},
		...mapGetters({
			pawnWorkDays: 'pawns/getPawnWorkDays',
			citiesList: 'location/getCitiesList',
			pawnsList: 'pawns/getPawnsList',
			userCity: 'location/getUserCity',
			userLocation: 'location/getUserLocation',
			filterData: 'pawns/getPawnsFiltersData',
			showClosestStatus: 'pawns/getShowCloses',
			showShowOnMap: 'pawns/getShowOnMap',
			currentPawn: 'pawns/getCurrentPawn',
			getCurrentRegion: 'pawns/getCurrentRegion',
			getPawnFormattedWorkDays: 'pawns/getPawnFormattedWorkDays',
		}),
	},
	methods: {
		async initMap() {
			mapInstance = await new mapsConstructor.Map("map", this.ymapState, {
				minZoom: 5,
				maxZoom: 18,
			})
			// mapSearch = await new mapsConstructor.control.SearchControl({
			// 	options: {
			// 		provider: 'yandex#search',
			// 		useMapBounds: true,
			// 		strictBounds: true,
			// 		results: 5,
			// 		boundedBy: mapInstance.getBounds()
			// 	}
			// });
			if (mapInstance) {
				await this.getUserGeolocation()
				this.customBalloon = this.createCustomBalloon()
				this.$watch('pawnsList', () => {
					this.addMarks()
				}, {immediate: true})
				this.$watch('showClosestStatus', () => {
					this.addMarks()
				})
			}
		},
		addMarks() {
			if (clusterer) {
				mapInstance.geoObjects.remove(clusterer)
			}

			if (!this.pawnsList.length || !mapInstance) return

			clusterer = new mapsConstructor.Clusterer({
				clusterIcons: [
					{
						href: this.currentPlacemark,
						size: [45, 45],
						offset: [-20, -40]
					},
					{
						href: this.currentPlacemark,
						size: [60, 60],
						offset: [-30, -55]
					}],
				clusterNumbers: [10],
				clusterIconContentLayout: null,
				openBalloonOnClick: false,
				disableClickZoom: false,
			})

			let geoObjects = [];

			for (let i = 0, len = this.pawnsList.length; i < len; i++) {
				if (
					!this.pawnsList[i].coords.lat ||
					!this.pawnsList[i].coords.lon
				) {
					continue;
				}
				geoObjects.push(this.createPawnPlacemark(this.pawnsList[i]));
			}

			let byDistance = new mapsConstructor.geoQuery(geoObjects).sortByDistance(userPlacemark ? userPlacemark.geometry.getCoordinates() : this.getInitialCords())

			let maxPointsLength = byDistance.getLength() > 5 ? 5 : byDistance.getLength()

			if (this.showClosestStatus) {
				for (let i = 0; i < maxPointsLength; i++) {
					clusterer.add(byDistance.get(i))
				}
			} else {
				byDistance.addTo(clusterer)
			}

			mapInstance.geoObjects.add(clusterer);

			if (this.currentPawn) {
				let currentPawnPlacemark = new mapsConstructor.geoQuery(clusterer.getGeoObjects()).search(`properties.balloonId == ${this.currentPawn.id}`)
				if (currentPawnPlacemark) {
					mapInstance.setBounds(currentPawnPlacemark.getBounds())
					currentPawnPlacemark.get(0).balloon.open()
					this.setCurrentPawn(null)
				}
			} else {
				mapInstance.setBounds(clusterer.getBounds(), {
					checkZoomRange: true
				});
			}

		},
		checkGeoRights() {
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition(() => {
					this.geoRights = true
				}, () => {
					this.geoRights = false
				})
			} else {
				this.geoRights = false
			}
		},
		getInitialCords() {
			if (this.userLocation) {
				return [this.userLocation.lat, this.userLocation.lon]
			} else if (this.filterData.city) {
				let selectedCity = this.citiesList.find(i => i.id === this.filterData.city)
				return [selectedCity.lat, selectedCity.lon]
			} else {
				return navigator.geolocation.getCurrentPosition((position) => {
					return [position.coords.latitude, position.coords.longitude]
				}, () => {
					return [55.751574, 37.573856]
				})
			}
		},
		createPawnPlacemark(pawn) {
			let coords = [pawn.coords.lat, pawn.coords.lon]
			let workTimeArr = []
			this.getPawnFormattedWorkDays(pawn.id).forEach((item) => {
				if (item.firstDay === item.lastDay) {
					workTimeArr.push(`${item.firstDay}: ${item.schedule}\n`)
				} else {
					workTimeArr.push(`${item.firstDay}-${item.lastDay}: ${item.schedule}\n`)
				}

			})

			let placemarkIcon = '/local/templates/.default/img/svg/placemark.svg'
			switch (pawn.theme) {
				case 'pectoral':
					placemarkIcon = '/local/templates/.default/img/svg/pectoral-placemark.svg'
					break
				case 'green':
					placemarkIcon = '/local/templates/.default/img/svg/donskoy-placemark.svg'
					break
			}

			let customPlacemark = new mapsConstructor.Placemark(coords, {
				hintContent: `${pawn.street ? pawn.street + ', ' : ''}${pawn.house ? pawn.house : ''}`,
				balloonContent: `${pawn.street ? pawn.street + ', ' : ''}${pawn.house ? pawn.house : ''}`,
				balloonWorkTime: workTimeArr,
				balloonAccepts: pawn.accepts,
				balloonRouteBtn: true,
				balloonId: pawn.id
			}, {
				iconLayout: 'default#image',
				iconImageHref: placemarkIcon,
				iconImageSize: [45, 45],
				iconImageOffset: [-20, -40],
				balloonShadow: true,
				balloonOffset: [0, 0],
				balloonLayout: this.customBalloon,
				balloonPanelMaxMapArea: 0
			})
            this.addOpenBalloonEvent(customPlacemark)

			return customPlacemark
		},

		createCustomBalloon() {
			let self = this
			let balloonConstructor = mapsConstructor.templateLayoutFactory.createClass(
				'<div class="addresses-tooltip">' +
				'<div class="addresses-tooltip__text">' +
				'<b>$[properties.balloonContent]</b>' +
				'{% if properties.balloonWorkTime %}<p>Режим работы <br>' +
				'{% for item in properties.balloonWorkTime %}' +
				'<span>{{item}}</span><br>' +
				'{% endfor %}' +


				'</p>{% endif %}' +
				'</div>' +
				'{% if properties.balloonAccepts.length %}<div class="addresses-tooltip__text">Что принимаем</div>' +
				'<div class="addresses-tooltip__icons">' +
				'{% for accept in properties.balloonAccepts %}' +
				'<div class="addresses-tooltip__icon">' +
				'<img src="{{accept.icon|raw}}" title="{{accept.name|raw}}" loading="lazy" alt="">' +
				'</div>' +
				'{% endfor %}' +
				'</div>{% endif %}' +
				'{% if properties.balloonRouteBtn %}<button class="addresses-tooltip__btn btn trans">Построить маршрут</button>{% endif %}' +
				'</div>'

				, {
					build: function () {
						balloonConstructor.superclass.build.call(this);

						this._$element = this.getParentElement().querySelector('.addresses-tooltip')

						this.routeBtn = this._$element.querySelector('.addresses-tooltip__btn')

						this.routeBtn.addEventListener('click', this.openRouter.bind(this))
					},
					openRouter: function (e) {
						e.preventDefault()
						self.routeData.showRouter = true
						self.routeData.addressTo.coords = this._data.geometry._coordinates
						self.routeData.addressTo.name = this._data.properties._data.balloonContent
						// eslint-disable-next-line
						window.sendYM('postroit-marshrut')
					},
					clear: function () {
						this.routeBtn.removeEventListener('click', this.openRouter)
						balloonConstructor.superclass.clear.call(this);
					}
				})
			return balloonConstructor
		},
		getUserGeolocation() {
			return new Promise(resolve => {
				let self = this
				if (multiRoute) {
					mapInstance.geoObjects.remove(multiRoute)
				}
				if (userPlacemark) {
					mapInstance.geoObjects.remove(userPlacemark)
				}
				mapsConstructor.geolocation.get().then((loc) => {
					this.userGeoLocation = loc.geoObjects
					userPlacemark = new mapsConstructor.GeoObject({
						// Описание геометрии.
						geometry: {
							type: "Point",
							coordinates: this.userGeoLocation.position
						},
					}, {
						// Опции.
						iconLayout: 'default#image',
						iconImageHref: '/local/templates/.default/img/svg/userPlacemark.svg',
						iconImageSize: [101, 33],
						iconImageOffset: [-7.5, -7.5],
						// Метку можно перемещать.
						draggable: true,
						hasBalloon: false,
						hasHint: false,
					})

					mapsConstructor.geocode(userPlacemark.geometry.getCoordinates(), {
						results: 1
					}).then(function (res) {
						let newAddress = res.geoObjects.get(0) ?
							res.geoObjects.get(0).properties.get('name') :
							'Не удалось определить адрес.';
						self.routeData.addressFrom.coords = res.geoObjects.get(0).geometry.getCoordinates()
						self.routeData.addressFrom.name = newAddress
					});


					userPlacemark.events.add('drag', () => {
						mapsConstructor.geocode(userPlacemark.geometry.getCoordinates(), {
							results: 1
						}).then(function (res) {
							let newAddress = res.geoObjects.get(0) ?
								res.geoObjects.get(0).properties.get('name') :
								'Не удалось определить адрес.';
							self.routeData.addressFrom.coords = res.geoObjects.get(0).geometry.getCoordinates()
							self.routeData.addressFrom.name = newAddress
						});
					})

					mapInstance.geoObjects.add(userPlacemark);
					resolve()
				})
			})
		},
		buildRoute() {
			if (multiRoute) {
				mapInstance.geoObjects.remove(multiRoute)
			}
			multiRoute = new mapsConstructor.multiRouter.MultiRoute({
				referencePoints: [
					this.routeData.addressFrom.coords,
					this.routeData.addressTo.coords
				],
				params: {
					results: 2
				}
			}, {
				wayPointVisible: false,
				boundsAutoApply: true,
				routeStrokeColor: "B9B9B9",
				routeActiveStrokeColor: "E24037",
			})
			mapInstance.balloon.close()
			mapInstance.geoObjects.add(multiRoute);
		},
		searchAddress(query) {
			return new Promise((resolve) => {
				
				if (!query) resolve([])
				mapsConstructor.suggest(query, {
					boundedBy: mapInstance.getBounds(),
					results: 7,
				})
				.then(function (items) {
					let arr = [];
					if (items.length) {
					items.forEach(item => {
						arr.push({
						name: item.value,
						coords: null,
						});
					});
					}
					resolve(arr);
				})
				.catch(function (error) {
					console.error(error);
					resolve([]);
				});
				// mapSearch.search(query).then(function () {
				// 	let results = mapSearch.getResultsArray()
				// 	let arr = []
				// 	if (results.length) {
				// 		results.forEach(item => {
				// 			arr.push({
				// 				name: item.properties.get('name'),
				// 				coords: item.geometry.getCoordinates()
				// 			})
				// 		})
				// 	}
				// 	resolve(arr)
				// })
			})
		},
        addOpenBalloonEvent(customPlacemark) {
            customPlacemark.events.add('balloonopen', function(e) {
                mapInstance.setCenter(e._sourceEvent.originalEvent.target.geometry._coordinates).then(function () {
                    const itsMobile = window.matchMedia("(max-width: 640px)").matches
                    const position = mapInstance.getGlobalPixelCenter();
                    mapInstance.setGlobalPixelCenter([ position[0] + (itsMobile ? 125 : 0), position[1] + 150 ]);
                }, function () {}, this);
            });
        },        
		async setSearchAddress() {
			let self = this
			if (userPlacemark) {
				mapInstance.geoObjects.remove(userPlacemark)
			}

			if (!this.routeData.addressFrom.coords) {
				await mapsConstructor.geocode(this.routeData.addressFrom.name, {results: 1}).then(res => {
					self.routeData.addressFrom.coords = res.geoObjects.get(0).geometry.getCoordinates()
				})
			}

			userPlacemark = new mapsConstructor.GeoObject({
				// Описание геометрии.
				geometry: {
					type: "Point",
					coordinates: this.routeData.addressFrom.coords 
				},
			}, {
				// Опции.
				iconLayout: 'default#image',
				iconImageHref: '/local/templates/.default/img/svg/userPlacemark.svg',
				iconImageSize: [101, 33],
				iconImageOffset: [-7.5, -7.5],
				// Метку можно перемещать.
				draggable: true,
				hasBalloon: false,
				hasHint: false,
			})

			userPlacemark.events.add('drag', () => {
				mapsConstructor.geocode(userPlacemark.geometry.getCoordinates(), {
					results: 1
				}).then(function (res) {
					let newAddress = res.geoObjects.get(0) ?
						res.geoObjects.get(0).properties.get('name') :
						'Не удалось определить адрес.';
					self.routeData.addressFrom.coords = res.geoObjects.get(0).geometry.getCoordinates()
					self.routeData.addressFrom.name = newAddress
				});
			})
			mapInstance.geoObjects.add(userPlacemark);
		},
		...mapMutations({
			setCurrentPawn: 'pawns/setCurrentPawn'
		})
	},
	watch: {
		showShowOnMap() {
			let currentPawnPlacemark = new mapsConstructor.geoQuery(clusterer.getGeoObjects()).search(`properties.balloonId == ${this.pawnsList[0].id}`)
			if (currentPawnPlacemark) {
				mapInstance.setBounds(currentPawnPlacemark.getBounds())
				currentPawnPlacemark.get(0).balloon.open()
			}
		}
	}
}
</script>

<style scoped>

</style>
